import {
  fetchRecoverUserReplyTemplate,
  type TRecoverUserReplyTemplateResponse,
  type TRecoverUserReplyTemplateRequest,
} from '../../repositories/chats/v1/recover-user-reply-template';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

const DEFAULT_ERROR_MESSAGE = 'Ошибка восстановления шаблона ответа';

export async function recoverUserReplyTemplatePublic(
  context: IApplicationContext,
  parameters: TRecoverUserReplyTemplateRequest,
) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TRecoverUserReplyTemplateResponse> =
      await fetchRecoverUserReplyTemplate({
        httpApi,
        parameters,
      });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.ReplyTemplates,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return response;
  } catch (e) {
    const exception = getGenericLikeError({
      error: e,
      domain: EExceptionDomain.ReplyTemplates,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/recover-user-reply-template/',
      parameters: JSON.stringify(parameters),
    });

    throw exception;
  }
}
